import React from "react"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import * as FaIcons from '@fortawesome/free-solid-svg-icons'
import "./GagCategory.css"

export default class GagCategory extends React.Component {

    constructor(props) {
        super(props);

        const {category, categorySequenceNumber, categoryTotalNumber, mediaSize, color} = this.props

        this.categoryColor = "hsla(" + color + ", 30%, 50%, 1)"
        this.handleMediamediaSizeLoad = mediaSize

        const {innerWidth: maxWidth, innerHeight: height} = window;
        this.maxWidth = maxWidth
        this.maxHeight = height

        const delayBasis = 100
        this.delayRender = categorySequenceNumber * delayBasis

        const baseX = (this.maxWidth + mediaSize.mediaWidth) / 2
        const positionLeft = 50 - (Math.random() * 50) + baseX + 'px'
        const positionTop = ((categorySequenceNumber - 1) * 85) + (this.maxHeight - 200 - (85 * categoryTotalNumber)) / 2

        this.state = {
            category: category,
            positionTop: positionTop,
            positionLeft: positionLeft,
            hidden: true
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({hidden: false})
        }, this.delayRender)
    }

    render() {

        if (this.state.hidden) {
            return ''
        }

        return <>
            <FontAwesomeIcon
                key={this.state.category.category.faIcon}
                //title not working
                // title={this.state.category.category.name}
                icon={FaIcons[this.state.category.category.faIcon]}
                className="faCategories faCategories-stamp"
                size="5x"
                style={{
                    top: this.state.positionTop,
                    left: this.state.positionLeft,
                    color: this.categoryColor
                }}
            />
        </>
    }
}